<template>
	 <div>
		<b-col cols="12">
			<h2>{{ $t('patient-panel.consultation-or-service')}}</h2>
		</b-col>
		<b-row class="neu-cards-ctn landing-cnt mt-5" cols="1" cols-xl="4">
			<PatientPanelServiceBlock id="my-consultations" visible :title="$t('patient-panel.consultations')" :action="() => $router.push('/patient/panel-search')" img="/static-appopensalud/img/icons/morillas-svg-icons/primary/medic.svg" />
			<PatientPanelServiceBlock id="new-consultation" visible :title="$t('patient-panel.services')" :action="() => $router.push('/patient/search/services')" img="/static-appopensalud/img/stethoscope-blue.svg" />
		</b-row>
	</div>
</template>

<script>
import PatientPanelServiceBlock from '@/components/PatientPanelServiceBlock.vue'
import BackButton from '@/components/base/buttons/BackButton'

export default {
	components: {
		PatientPanelServiceBlock,
		BackButton
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/PanelSearchSelector.vue